import React from 'react';
import { IntlProvider } from 'react-intl';
import './App.css';
import 'react-datepicker/dist/react-datepicker.min.css';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import nl from 'date-fns/locale/nl';
import Peek from './components/Peek/Peek';
import Stepper from './components/Stepper';
import Wizard from './components/Wizard';
import useMessages from './hooks/useMessages';
import WizardProvider from './providers/WizardProvider';
import StepTracker from "./components/StepTracker";

registerLocale('nl', nl);
setDefaultLocale('nl');
declare global {
  interface Window {
    bookAppointmentCulture?: string;
  }
}

const locale = window.bookAppointmentCulture || 'nl-NL';

function App(): JSX.Element {
  const messages = useMessages(locale);
  return (
    <div className='App'>
      {messages ? (
        <IntlProvider locale={locale} messages={messages}>
          <WizardProvider>
            <Stepper />
            <StepTracker />
            <Wizard />
            <Peek />
          </WizardProvider>
        </IntlProvider>
      ) : null}
    </div>
  );
}

export default App;
